<template>
    <div>
        <app-data-table
            :fields="fields"
            :items="items.data"
            @sort="onSort"
            :current-page="items.current_page"
            :last-page="items.last_page"
            :from="items.from"
            :to="items.to"
            :total="items.total"
            :per-page="items.per_page"
            :on-change-page="onChangePage"
        >
            <template slot="start_date" slot-scope="{ item }">
                {{ item.start_date | datetime }}
            </template>
            <template slot="end_date" slot-scope="{ item }">
                {{ item.end_date | datetime }}
            </template>
            <template slot="out_of_city" slot-scope="{ item }">
                {{ item.out_of_city | yesno }}
            </template>
            <template slot="status" slot-scope="{ item }">
                {{ !!item.end_date ? 'Finalizado' : 'En Progreso' }}
            </template>
            <template slot="duration" slot-scope="{ item }">
                <span if="!!item.end_date">
                    {{
                        !!item.end_date
                            ? Math.ceil(
                                  moment(item.end_date).diff(
                                      moment(item.start_date),
                                      'minutes'
                                  ) / 60
                              ) + ' hora(s)'
                            : ''
                    }}
                </span>
            </template>
            <template slot="signature" slot-scope="{ item }">
                <b-img
                    :src="item.signature_url"
                    style="max-height: 25px"
                ></b-img>
            </template>
            <template slot="actions" slot-scope="{ item }">
                <b-btn variant="primary" @click="showService(item)" size="sm"
                    ><i class="fa fa-search-plus"></i
                ></b-btn>
            </template>
        </app-data-table>
        <app-pop-up
            size="large"
            id="service-window"
            title="Información Servicio de Escolta"
        >
            <template slot="body">
                <app-bodyguard-service-card
                    :bodyguard-service="selectedService"
                    v-if="!!selectedService"
                />
            </template>
        </app-pop-up>
    </div>
</template>
<script>
import BodyguardServiceCard from '../../BodyguardServices/BodyguardServiceCard/BodyguardServiceCard'
export default {
    name: 'bodyguard_list',
    components: {
        appBodyguardServiceCard: BodyguardServiceCard,
    },
    props: {
        items: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        fields: [
            {
                key: 'type',
                label: 'Tipo',
            },
            {
                key: 'client.name',
                label: 'Cliente',
            },
            {
                key: 'user.name',
                label: 'Escolta',
            },
            {
                key: 'city.name',
                label: 'Ciudad',
            },
            {
                key: 'driver_person_name',
                label: 'Conductor / Persona',
            },
            {
                key: 'plate_document',
                label: 'Placa / Documento',
            },
            {
                key: 'out_of_city',
                label: 'Fuera de la ciudad',
            },
            {
                key: 'town.name',
                label: 'Lugar',
                orderBy: 'towns.name',
            },
            {
                key: 'start_date',
                label: 'Fecha de inicio',
            },
            {
                key: 'end_date',
                label: 'Fecha de finalización',
            },
            {
                key: 'duration',
                label: 'Duración',
                sortable: false,
            },
            {
                key: 'status',
                label: 'Estado',
                sortable: false,
            },
            {
                key: 'signature',
                label: 'Firma',
                sortable: false,
            },
            {
                key: 'actions',
                label: 'Acciones',
            },
        ],
        selectedService: '',
    }),
    methods: {
        showService(service) {
            this.selectedService = service
            this.$bus.$emit('service-window.open')
        },
        onChangePage(page) {
            this.$emit('changePage', page)
        },
        onSort(ctx) {
            this.$emit('sort', ctx)
        },
    },
}
</script>
